import React, { useRef } from "react";

const OTPInput = ({ length = 6, onChange }) => {
  const inputs = useRef([]);

  const handleChange = (e, index) => {
    const value = e.target.value.toUpperCase();

    if (/^[A-Z0-9]{0,1}$/.test(value)) {
      e.target.value = value;
      if (value && index < length - 1) {
        inputs.current[index + 1].focus();
      }
      handleOTPChange();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputs.current[index - 1].focus();
    }
  };

  const handleOTPChange = () => {
    const otp = inputs.current.map((input) => input.value).join("");
    onChange && onChange(otp);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        marginTop: "20px",
      }}
      className="otp-input-container"
    >
      {Array.from({ length }).map((_, index) => (
        <input
          key={index}
          maxLength={1}
          ref={(el) => (inputs.current[index] = el)}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          // style={{
          //   width: '40px',
          //   height: '40px',
          //   fontSize: '24px',
          //   textAlign: 'center',
          //   border: '1px solid #ccc',
          //   borderRadius: '4px',
          // }}
          className={
            "otp-input " + (inputs.current[index]?.value ? "has-value" : "")
          }
        />
      ))}
    </div>
  );
};

export default OTPInput;
